/**
 * Constants for field formatting context identifiers
 */
export const FieldFormattingContext = {
  ALL_FIELDS: '__ALL_FIELDS__',
  ALL_VALUES: '__ALL_VALUES__',
  VALUE_SUFFIX: '__VALUE__'
} as const;

/**
 * Helper function to create value context from field name
 */
export function createValueContext(fieldName: string): string {
  return `${fieldName}${FieldFormattingContext.VALUE_SUFFIX}`;
}

/**
 * Helper function to extract field name from value context
 */
export function extractFieldNameFromValueContext(context: string): string {
  return context.replace(FieldFormattingContext.VALUE_SUFFIX, '');
}

/**
 * Check if context is for all fields
 */
export function isAllFieldsContext(context: string): boolean {
  return context === FieldFormattingContext.ALL_FIELDS;
}

/**
 * Check if context is for all values
 */
export function isAllValuesContext(context: string): boolean {
  return context === FieldFormattingContext.ALL_VALUES;
}

/**
 * Check if context is for a value (not label)
 */
export function isValueContext(context: string): boolean {
  return context.endsWith(FieldFormattingContext.VALUE_SUFFIX) ||
         context === FieldFormattingContext.ALL_VALUES;
}

